export default [
  'clickAddRemoveColumns',
  'clickAddCustomFieldFromAddRemoveColumns',
  'clickColumnReset',
  'searchFieldsColumnManager',
  'selectAllColumns'
]
